// Closed allow-list; any other value reads as none.
export const SIGN_IN_ERROR_PARAM = 'error'

export type SignInError = 'signin_failed'

const KNOWN: readonly SignInError[] = ['signin_failed']

export function readSignInError(search: string): SignInError | null {
  const value = new URLSearchParams(search).get(SIGN_IN_ERROR_PARAM)
  return KNOWN.find(known => known === value) ?? null
}
